import { render, staticRenderFns } from "./VimeoModal.vue?vue&type=template&id=38bfca02&scoped=true"
import script from "./VimeoModal.vue?vue&type=script&lang=js"
export * from "./VimeoModal.vue?vue&type=script&lang=js"
import style0 from "./VimeoModal.vue?vue&type=style&index=0&id=38bfca02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfca02",
  null
  
)

export default component.exports